import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './GlobalStyle';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import NotFoundPage from './pages/NotFoundPage';
import TestimonialsPage from './pages/TestimonialsPage';
import WorkWithUs from './pages/WorkWithUs';
const ScrollToTop = () => {
const { pathname } = useLocation();
useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
return null;
};
const App = () => {
return (
<ThemeProvider theme={theme}>
<GlobalStyle />
<ScrollToTop />
<Navbar />
<Routes>
<Route path="/" element={<Home />} />
<Route path="/about" element={<About />} />
<Route path="/services" element={<Services />} />
<Route path="/services/:id" element={<ServiceDetail />} />
<Route path="/contact" element={<Contact />} />
<Route path="/testimonials" element={<TestimonialsPage />} />
<Route path="/work-with-us" element={<WorkWithUs />} />
<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/terms-of-service" element={<TermsOfService />} />
<Route path="*" element={<NotFoundPage />} />
</Routes>
<Footer />
</ThemeProvider>
);
};
export default App;
